<template>
  <div class="profile">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">Profile</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Profile</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="card mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="profile-view">
                    <div class="profile-img-wrap">
                      <div class="profile-img">
                        <a @click="openChangePhoto"
                          ><img
                            alt=""
                            :src="media + employee.passportPhoto"
                            v-if="employee.passportPhoto"/>
                          <img
                            alt=""
                            src="~@/assets/profiles/avatar-02.jpg"
                            v-if="!employee.passportPhoto"
                        /></a>
                      </div>
                    </div>
                    <div class="profile-basic">
                      <div class="row">
                        <div class="col-md-5">
                          <div class="profile-info-left">
                            <h3 class="user-name m-t-0 mb-0">
                              {{ employee.firstName + " " + employee.lastName }}
                            </h3>
                            <h6 class="text-muted">
                              {{ employee.designation.name }}
                            </h6>
                            <small class="text-muted">{{
                              employee.designation.department.name
                            }}</small>
                            <div class="staff-id">
                              Employee ID : {{ employee.employeeCode }}
                            </div>
                            <div class="staff-id">
                              Business Unit : {{ companyUnit.name }}
                            </div>
                            <div class="small doj text-muted">
                              Date of Join :
                              {{
                                employee.joinDate
                                  ? new Date(
                                      employee.joinDate
                                    ).toLocaleDateString()
                                  : ""
                              }}
                            </div>
                            <div class="small doj text-muted">
                              State :
                              {{ employee.state }}
                            </div>
                            <!-- <div class="staff-msg">
                              <router-link to="/chat" class="btn btn-custom"
                                >Send Message
                              </router-link>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-md-7">
                          <ul class="personal-info">
                            <li>
                              <div class="title">Phone:</div>
                              <div class="text">
                                {{ employee.phone }}
                              </div>
                            </li>
                            <li>
                              <div class="title">Email:</div>
                              <div class="text">
                                <a href="">{{ employee.email }}</a>
                              </div>
                            </li>
                            <li>
                              <div class="title">Birthday:</div>
                              <div class="text">
                                {{
                                  new Date(
                                    employee.birthday
                                  ).toLocaleDateString()
                                }}
                              </div>
                            </li>
                            <li>
                              <div class="title">Address:</div>
                              <div class="text">{{ employee.address }}</div>
                            </li>
                            <li>
                              <div class="title">Gender:</div>
                              <div class="text">{{ employee.gender }}</div>
                            </li>
                            <li>
                              <div class="title">Admin. Reports to:</div>
                              <div class="text" v-if="employee.employeeManager">
                                <div class="avatar-box">
                                  <div class="avatar avatar-xs">
                                    <img
                                      alt=""
                                      :src="
                                        media +
                                          employee.employeeManager.manager
                                            .passportPhoto
                                      "
                                      v-if="
                                        employee.employeeManager.manager
                                          .passportPhoto
                                      "
                                    />
                                    <img
                                      alt=""
                                      src="~@/assets/profiles/avatar-02.jpg"
                                      v-if="
                                        !employee.employeeManager.manager
                                          .passportPhoto
                                      "
                                    />
                                  </div>
                                </div>
                                <div>
                                  {{
                                    employee.employeeManager.manager.firstName +
                                      " " +
                                      employee.employeeManager.manager.lastName
                                  }}
                                </div>
                              </div>
                              <div class="text" v-else>
                                <div class="d-flex">
                                  <span class="">No Manager Assigned</span>
                                  <span class="mx-2">|</span>
                                  <a class=" text-primary" @click="openAdminDialog"
                                    >Assign</a
                                  >
                                </div>
                              </div>
                            </li>
                            <li>
                              <div class="title">Admin. II Reports to:</div>
                              <div
                                class="text"
                                v-if="employee.employeeStage2Manager"
                              >
                                <div class="avatar-box">
                                  <div class="avatar avatar-xs">
                                    <img
                                      alt=""
                                      :src="
                                        media +
                                          employee.employeeStage2Manager.manager
                                            .passportPhoto
                                      "
                                      v-if="
                                        employee.employeeStage2Manager.manager
                                          .passportPhoto
                                      "
                                    />
                                    <img
                                      alt=""
                                      src="~@/assets/profiles/avatar-02.jpg"
                                      v-if="
                                        !employee.employeeStage2Manager.manager
                                          .passportPhoto
                                      "
                                    />
                                  </div>
                                </div>
                                <div>
                                  {{
                                    employee.employeeStage2Manager.manager
                                      .firstName +
                                      " " +
                                      employee.employeeStage2Manager.manager
                                        .lastName
                                  }}
                                </div>
                              </div>
                              <div class="text" v-else>
                                <div class="d-flex">
                                  <span class="">No Manager Assigned</span>
                                  <span class="mx-2">|</span>
                                  <a class=" text-primary" @click="openIDialog"
                                    >Assign</a
                                  >
                                </div>
                              </div>
                            </li>
                            <li>
                              <div class="title">Expense Reports to:</div>
                              <div
                                class="text"
                                v-if="employee.operationalEmployeeManager"
                              >
                                <div class="avatar-box">
                                  <div class="avatar avatar-xs">
                                    <img
                                      alt=""
                                      :src="
                                        media +
                                          employee.operationalEmployeeManager
                                            .manager.passportPhoto
                                      "
                                      v-if="
                                        employee.operationalEmployeeManager
                                          .manager.passportPhoto
                                      "
                                    />
                                    <img
                                      alt=""
                                      src="~@/assets/profiles/avatar-02.jpg"
                                      v-if="
                                        !employee.operationalEmployeeManager
                                          .manager.passportPhoto
                                      "
                                    />
                                  </div>
                                </div>
                                <div>
                                  {{
                                    employee.operationalEmployeeManager.manager
                                      .firstName +
                                      " " +
                                      employee.operationalEmployeeManager
                                        .manager.lastName
                                  }}
                                </div>
                              </div>
                              <div class="text" v-else>
                                <div class="d-flex">
                                  <span class="">No Approver Assigned</span>
                                  <span class="mx-2">|</span>
                                  <a class=" text-primary" @click="openExpenseDialog"
                                    >Assign</a
                                  >
                                </div>
                              </div>
                            </li>
                            <li>
                              <div class="title">Expense II Reports to:</div>
                              <div
                                class="text"
                                v-if="employee.operationalEmployeeStage2Manager"
                              >
                                <div class="avatar-box">
                                  <div class="avatar avatar-xs">
                                    <img
                                      alt=""
                                      :src="
                                        media +
                                          employee
                                            .operationalEmployeeStage2Manager
                                            .manager.passportPhoto
                                      "
                                      v-if="
                                        employee
                                          .operationalEmployeeStage2Manager
                                          .manager.passportPhoto
                                      "
                                    />
                                    <img
                                      alt=""
                                      src="~@/assets/profiles/avatar-02.jpg"
                                      v-if="
                                        !employee
                                          .operationalEmployeeStage2Manager
                                          .manager.passportPhoto
                                      "
                                    />
                                  </div>
                                </div>
                                <div>
                                  {{
                                    employee.operationalEmployeeStage2Manager
                                      .manager.firstName +
                                      " " +
                                      employee.operationalEmployeeStage2Manager
                                        .manager.lastName
                                  }}
                                </div>
                              </div>
                              <div class="text" v-else>
                                <div class="d-flex">
                                  <span class="">No Approver Assigned</span>
                                  <span class="mx-2">|</span>
                                  <a class=" text-primary" @click="openIIDialog"
                                    >Assign</a
                                  >
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="pro-edit">
                      <a
                        @click="openProfile"
                        v-if="myAccount"
                        class="edit-icon"
                        href="#"
                        ><i class="fa fa-pencil"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card tab-box">
            <div class="row user-tabs">
              <div class="col-lg-12 col-md-12 col-sm-12 line-tabs">
                <ul class="nav nav-tabs nav-tabs-bottom">
                  <li class="nav-item">
                    <a
                      href="#emp_profile"
                      data-toggle="tab"
                      class="nav-link active"
                      >Profile</a
                    >
                  </li>

                  <li class="nav-item">
                    <a
                      href="#bank_statutory"
                      data-toggle="tab"
                      v-if="hrAccount"
                      class="nav-link"
                      >Bank & Statutory</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="tab-content">
            <!-- Profile Info Tab -->
            <div
              id="emp_profile"
              class="pro-overview tab-pane fade show active"
            >
              <div class="row">
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Personal Informations
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click="openPersonalInfo"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <ul class="personal-info">
                        <li>
                          <div class="title">Passport No.</div>
                          <div class="text">
                            {{ employee.passportIdentificationNumber }}
                          </div>
                        </li>
                        <li>
                          <div class="title">Passport Exp Date.</div>
                          <div class="text">
                            {{
                              new Date(
                                employee.passportExpiryDate
                              ).toLocaleDateString()
                            }}
                          </div>
                        </li>
                        <li>
                          <div class="title">NIN</div>
                          <div class="text">
                            {{ employee.nationalIdentityNumber }}
                          </div>
                        </li>
                        <li>
                          <div class="title">Tel</div>
                          <div class="text">
                            {{ employee.phone }}
                          </div>
                        </li>
                        <li>
                          <div class="title">Nationality</div>
                          <div class="text">{{ employee.nationality }}</div>
                        </li>
                        <li>
                          <div class="title">Religion</div>
                          <div class="text">{{ employee.religion }}</div>
                        </li>
                        <li>
                          <div class="title">Marital status</div>
                          <div class="text">{{ employee.maritalStatus }}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Emergency Contact
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click="openEmergencyContact"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div v-if="employee.employeeEmergencies">
                        <div v-if="employee.employeeEmergencies.length > 0">
                          <h5 class="section-title">Primary</h5>
                          <ul class="personal-info">
                            <li>
                              <div class="title-label">Name</div>
                              <div class="text">
                                {{ employee.employeeEmergencies[0].name }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Relationship</div>
                              <div class="text">
                                {{
                                  employee.employeeEmergencies[0].relationship
                                }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Phone</div>
                              <div class="text">
                                {{
                                  employee.employeeEmergencies[0].phone1 +
                                    ", " +
                                    employee.employeeEmergencies[0].phone2
                                }}
                              </div>
                            </li>
                          </ul>
                          <hr />
                          <h5
                            class="section-title"
                            v-if="employee.employeeEmergencies.length > 1"
                          >
                            Secondary
                          </h5>
                          <ul
                            class="personal-info"
                            v-if="employee.employeeEmergencies.length > 1"
                          >
                            <li>
                              <div class="title-label">Name</div>
                              <div class="text">
                                {{ employee.employeeEmergencies[1].name }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Relationship</div>
                              <div class="text">
                                {{
                                  employee.employeeEmergencies[1].relationship
                                }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Phone</div>
                              <div class="text">
                                {{
                                  employee.employeeEmergencies[1].phone1 +
                                    ", " +
                                    employee.employeeEmergencies[1].phone2
                                }}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Bank information
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="employee.employeeBank == null"
                          @click.prevent="openBankInfo"
                          ><i class="fa fa-pencil"></i
                        ></a>
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="employee.employeeBank"
                          @click.prevent="openBankInfoEdit"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <ul class="personal-info" v-if="employee.employeeBank">
                        <li>
                          <div class="title-label">Bank name</div>
                          <div class="text">
                            {{
                              employee.employeeBank
                                ? employee.employeeBank.bankName
                                : ""
                            }}
                          </div>
                        </li>
                        <li>
                          <div class="title-label">Bank account No.</div>
                          <div class="text">
                            {{
                              employee.employeeBank
                                ? employee.employeeBank.bankAccountNumber
                                : ""
                            }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Family Information
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click="openFamilyInfo"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div class="table-responsive">
                        <table class="table table-nowrap">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Relationship</th>
                              <th>Phone</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in employee.employeeFamilies"
                              :key="item.id"
                            >
                              <td>{{ item.name }}</td>
                              <td>{{ item.relationship }}</td>
                              <td>{{ item.phoneNo }}</td>
                              <td class="text-right">
                                <div class="dropdown dropdown-action">
                                  <a
                                    aria-expanded="false"
                                    data-toggle="dropdown"
                                    class="action-icon dropdown-toggle"
                                    href="#"
                                    ><i class="material-icons">more_vert</i></a
                                  >
                                  <div
                                    class="dropdown-menu dropdown-menu-right"
                                  >
                                    <a
                                      @click="openFamilyInfo"
                                      class="dropdown-item"
                                      ><i class="fa fa-pencil m-r-5"></i>
                                      Edit</a
                                    >
                                    <a
                                      href="#"
                                      class="dropdown-item"
                                      @click="OpenDeleteFamilyData(item)"
                                      ><i class="fa fa-trash-o m-r-5"></i>
                                      Delete</a
                                    >
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Education Information
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click="openEducation"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div class="experience-box">
                        <ul class="experience-list">
                          <li
                            v-for="item in employee.employeeEducations"
                            :key="item.id"
                          >
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <a
                                  href="#/"
                                  class="name"
                                  @click="openEducationEdit(item)"
                                  >{{ item.institute }}</a
                                >
                                <div>{{ item.discipline }}</div>
                                <span class="time"
                                  >{{
                                    new Date(item.startYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{ new Date(item.startYear).getFullYear() }} -
                                  {{
                                    new Date(item.endYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{
                                    new Date(item.endYear).getFullYear()
                                  }}</span
                                >
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Experience
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click="openExperience"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div class="experience-box">
                        <ul class="experience-list">
                          <li
                            v-for="item in employee.employeeExperiences"
                            :key="item.id"
                          >
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <a href="#/" class="name">{{
                                  item.companyName
                                }}</a>
                                <span class="time"
                                  >{{
                                    new Date(item.startYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{ new Date(item.startYear).getFullYear() }} -
                                  {{
                                    new Date(item.endYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{
                                    new Date(item.endYear).getFullYear()
                                  }}</span
                                >
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 d-flex" v-if="profileNOK">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Next Of Kin Information
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click="openNOK"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <ul
                        class="personal-info"
                        v-if="employee.employeeNextOfKin"
                      >
                        <li>
                          <div class="title-label">Full Name</div>
                          <div class="text">
                            {{ employee.employeeNextOfKin.fullName }}
                          </div>
                        </li>
                        <li>
                          <div class="title-label">Address</div>
                          <div class="text">
                            {{ employee.employeeNextOfKin.address }}
                          </div>
                        </li>
                        <li>
                          <div class="title-label">Phone No.</div>
                          <div class="text">
                            {{ employee.employeeNextOfKin.phone }}
                          </div>
                        </li>
                        <li>
                          <div class="title-label">Relationship</div>
                          <div class="text">
                            {{ employee.employeeNextOfKin.relationship }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 d-flex" v-if="profileGLI">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Group Life Assurance Beneficiary Information
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click="openGLI"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div class="table-responsive">
                        <table class="table table-nowrap">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Relationship</th>
                              <th>Percentage</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in employee.employeeGLIs"
                              :key="item.id"
                            >
                              <td>{{ item.fullName }}</td>
                              <td>{{ item.relationship }}</td>
                              <td>{{ item.percentage }}%</td>
                              <td class="text-right">
                                <div class="dropdown dropdown-action">
                                  <a
                                    aria-expanded="false"
                                    data-toggle="dropdown"
                                    class="action-icon dropdown-toggle"
                                    href="#"
                                    ><i class="material-icons">more_vert</i></a
                                  >
                                  <div
                                    class="dropdown-menu dropdown-menu-right"
                                  >
                                    <a
                                      @click="openFamilyInfo"
                                      class="dropdown-item"
                                      ><i class="fa fa-pencil m-r-5"></i>
                                      Edit</a
                                    >
                                    <a href="#" class="dropdown-item"
                                      ><i class="fa fa-trash-o m-r-5"></i>
                                      Delete</a
                                    >
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Profile Info Tab -->
            <!-- Bank Statutory Tab -->
            <div class="tab-pane fade" id="bank_statutory">
              <div class="card">
                <div class="card-body">
                  <h3 class="card-title">Basic Salary Information</h3>
                  <form @submit.prevent="onPostStatutory">
                    <div class="row">
                      <!-- <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Salary basis
                            <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            v-model="employee.employeeStatutory.salaryBasis"
                          >
                            <option>Select salary basis type</option>
                            <option value="hourly">Hourly</option>
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                            <option value="monthly">Monthly</option>
                          </select>
                        </div>
                      </div> -->
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Salary amount
                            <small class="text-muted">per month</small></label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">₦</span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Type your salary amount"
                              v-model="employee.employeeStatutory.salaryAmount"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <h3 class="card-title">PF Information</h3>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-form-label"
                            >PF No. <span class="text-danger">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-model="employee.employeePension.pensionNo"
                            placeholder="Type your pension number"
                          />
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-form-label">PF Manager</label>
                          <select
                            class="form-control"
                            v-model="employee.employeePension.pensionManager"
                          >
                            <option>Select Pension Manager</option>
                            <option
                              v-for="item in pensionManagers"
                              :key="item.lookupValue"
                              :value="item.lookupValue"
                              >{{ item.lookupDescription }}</option
                            >
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Employee PF rate
                            <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            v-model="employee.employeePension.employeeRate"
                          >
                            <option>Select PF rate</option>
                            <option value="0">0%</option>
                            <option value="1">1%</option>
                            <option value="2">2%</option>
                            <option value="3">3%</option>
                            <option value="4">4%</option>
                            <option value="5">5%</option>
                            <option value="6">6%</option>
                            <option value="7">7%</option>
                            <option value="8">8%</option>
                            <option value="9">9%</option>
                            <option value="10">10%</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <h3 class="card-title">Tax Information</h3>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Tax Identification No.
                            <span class="text-danger">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-model="employee.employeeTax.tin"
                            placeholder="Type your tax identification number"
                          />
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Tax State <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            v-model="employee.employeeTax.taxCode"
                            @change="changeTax($event)"
                          >
                            <option>Select Tax State</option>
                            <option
                              v-for="item in taxOffices"
                              :key="item.lookupValue"
                              :value="item.lookupValue"
                              >{{ item.lookupDescription }}</option
                            >
                          </select>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <h3 class="card-title">NHF Information</h3>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-form-label"
                            >NHF No. <span class="text-danger">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-model="employee.employeeNHF.nhfNo"
                            placeholder="Type your tax identification number"
                          />
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-form-label"
                            >State <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            v-model="employee.employeeNHF.state"
                          >
                            <option>Select State</option>
                            <option
                              v-for="item in taxOffices"
                              :key="item.lookupValue"
                              :value="item.lookupValue"
                              >{{ item.lookupDescription }}</option
                            >
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="submit-section">
                      <button class="btn btn-primary submit-btn" type="submit">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /Bank Statutory Tab -->
          </div>
        </div>
        <!-- /Page Content -->
        <emergency-contact-modal
          :model="employee.employeeEmergencies"
          :id="this.$route.params.id"
          :dialog="emergencyContactDialog"
          v-if="emergencyContactDialog"
          :method="closeEmergencyContact"
        ></emergency-contact-modal>
        <personal-info-modal
          :model="employee"
          :dialog="personalInfoDialog"
          v-if="personalInfoDialog"
          :method="closePersonalInfo"
        ></personal-info-modal>
        <profile-modal
          :model="employee"
          :dialog="profileDialog"
          v-if="profileDialog"
          :method="closeProfile"
          :employees="employees"
        ></profile-modal>
        <!-- <bank-info-modal
          :model="employee.employeeBank"
          :id="this.$route.params.id"
          :dialog="bankInfoDialog"
          v-if="bankInfoDialog"
          :method="closeBankInfo"
        ></bank-info-modal> -->
        <family-info-modal
          :model="employee.employeeFamilies"
          :id="this.$route.params.id"
          :dialog="familyInfoDialog"
          v-if="familyInfoDialog"
          :method="closeFamilyInfo"
        ></family-info-modal>
        <experience-modal
          :model="employee.employeeExperiences"
          :id="this.$route.params.id"
          :dialog="experienceDialog"
          v-if="experienceDialog"
          :method="closeExperience"
        ></experience-modal>
        <education-modal
          :model="employee.employeeEducations"
          :id="this.$route.params.id"
          :dialog="educationDialog"
          v-if="educationDialog"
          :method="closeEducation"
        ></education-modal>
        <nextOfKin-modal
          :model="employee.employeeNextOfKin"
          :id="this.$route.params.id"
          :dialog="nextOfKinDialog"
          v-if="nextOfKinDialog"
          :method="closeNOK"
        ></nextOfKin-modal>
        <gli-modal
          :model="employee.employeeGLIs"
          :id="this.$route.params.id"
          :dialog="gliDialog"
          v-if="gliDialog"
          :method="closeGLI"
        ></gli-modal>
        <v-dialog v-model="changePhotodialog" max-width="230px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Change Photo</h5>
              <button type="button" class="close" @click="closeChangePhoto">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-md-12">
                <img alt="" :src="file" width="200" />
              </div>
              <div class="col-md-12">
                <button class="btn btn-info" @click="handleFileUpload">
                  Change Photo
                </button>
                <input
                  type="file"
                  style="display: none"
                  ref="file"
                  accept="image/*"
                  @change="onFilePicked"
                />
              </div>
            </div>
          </div>
        </v-dialog>

        <!-- education edit model -->
        <v-dialog v-model="EductionEditDialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Education Information</h5>
              <button type="button" class="close" @click="closeEducationEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="postEditedEducation">
                <div class="form-scroll">
                  <div class="card">
                    <div class="card-body">
                      <h3 class="card-title">
                        Education Informations
                        <a
                          href="javascript:void(0);"
                          class="delete-icon"
                          @click="openDeleteEducation(education.id)"
                          ><i class="fa fa-trash-o"></i
                        ></a>
                      </h3>
                      <div class="row">
                        <div class="col-md-12">
                          <div
                            class="alert alert-danger alert-dismissible fade show"
                            role="alert"
                            v-if="error"
                          >
                            <strong>Error!</strong> {{ error }}
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div
                            class="alert alert-success alert-dismissible fade show"
                            role="alert"
                            v-if="message"
                          >
                            <strong>Success!</strong> {{ message }}
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group form-focus focused">
                            <input
                              type="text"
                              v-model="education.institute"
                              class="form-control floating"
                              style="height: 55px !important"
                            />
                            <label class="focus-label">Institution</label>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group form-focus focused">
                            <input
                              type="text"
                              v-model="education.discipline"
                              class="form-control floating"
                              style="height: 55px !important"
                            />
                            <label class="focus-label">Discipline</label>
                          </div>
                        </div>
                        <div class="col-md-6 mb-5">
                          <div class="form-group form-focus focused">
                            <div class="cal-icon">
                              <!-- <input type="text"   v-model.trim="$v.startYear.$model"
																	class="form-control floating datetimepicker" style="height: 55px !important;"> -->
                              <datepicker
                                v-model="education.startYear"
                                calendar-class
                                input-class
                                bootstrap-styling
                                class="form-control datetimepicker"
                                type="text"
                              />
                            </div>
                            <label class="focus-label">Starting Date</label>
                          </div>
                        </div>
                        <div class="col-md-6 mb-5">
                          <div class="form-group form-focus focused">
                            <div class="cal-icon">
                              <!-- <input type="text"   v-model.trim="$v.endYear.$model"
																	class="form-control floating datetimepicker" style="height: 55px !important;"> -->
                              <datepicker
                                v-model="education.endYear"
                                calendar-class
                                input-class
                                bootstrap-styling
                                class="form-control datetimepicker"
                                type="text"
                              />
                            </div>
                            <label class="focus-label">Complete Date</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>

        <!-- Delete Education Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDelete">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete Education</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteEducationInfo"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      @click="closeDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete education Modal -->

        <!-- Delete Family Modal -->
        <v-dialog v-model="dialogDeleteFamily" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDelete">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete Family</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteFamilyInfo"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      @click="closeDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete family Modal -->

        <v-dialog v-model="bankInfoDialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Bank Information</h5>
              <button type="button" class="close" @click="closeBankInfo">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="postBank">
                <div class="form-scroll">
                  <div class="card">
                    <div class="card-body">
                      <h3 class="card-title">Bank Information</h3>
                      <div class="row">
                        <div class="col-md-12">
                          <div
                            class="alert alert-danger alert-dismissible fade show"
                            role="alert"
                            v-if="error"
                          >
                            <strong>Error!</strong> {{ error }}
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div
                            class="alert alert-success alert-dismissible fade show"
                            role="alert"
                            v-if="message"
                          >
                            <strong>Success!</strong> {{ message }}
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label
                              >Account Number
                              <span class="text-danger">*</span></label
                            >
                            <input
                              class="form-control"
                              v-model.trim="$v.bankAccountNumber.$model"
                              type="text"
                            />
                          </div>
                          <div
                            v-if="submitted && !$v.bankAccountNumber.required"
                            class="invalid-feedback"
                          >
                            Account Number is required
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label
                              >Bank Name
                              <span class="text-danger">*</span></label
                            >

                            <multiselectvue
                              class="from-control"
                              v-model="selectedBank"
                              placeholder="Select Bank"
                              :custom-label="nameOfDesignation"
                              :options="banks"
                              :searchable="true"
                              @select="optionSelectDesignation"
                              :allow-empty="false"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.lookupDescription }}</template
                              >
                            </multiselectvue>
                          </div>
                        </div>
                        <!-- <div class="col-md-12">
                          <div class="form-group">
                            <label
                              >Bank Verification Number
                              <span class="text-danger">*</span></label
                            >
                            <input
                              class="form-control"
                              v-model.trim="$v.bvnNumber.$model"
                              type="text"
                            />
                          </div>
                          <div
                            v-if="submitted && !$v.bvnNumber.required"
                            class="invalid-feedback"
                          >
                            Bank Verification Number is required
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Family Info Modal -->

        <v-dialog v-model="bankInfoDialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Bank Information</h5>
              <button type="button" class="close" @click="closeBankInfo">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="upDateBank">
                <div class="form-scroll">
                  <div class="card">
                    <div class="card-body">
                      <h3 class="card-title">Bank Information</h3>
                      <div class="row">
                        <div class="col-md-12">
                          <div
                            class="alert alert-danger alert-dismissible fade show"
                            role="alert"
                            v-if="error"
                          >
                            <strong>Error!</strong> {{ error }}
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div
                            class="alert alert-success alert-dismissible fade show"
                            role="alert"
                            v-if="message"
                          >
                            <strong>Success!</strong> {{ message }}
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label
                              >Account Number
                              <span class="text-danger">*</span></label
                            >
                            <input
                              v-if="
                                employee.employeeBank
                                  ? employee.employeeBank.bankAccountNumber
                                  : ''
                              "
                              class="form-control"
                              v-model="employee.employeeBank.bankAccountNumber"
                              type="text"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label
                              >Bank Name
                              <span class="text-danger">*</span></label
                            >

                            <!-- <multiselectvue
                              class="from-control"
                              v-if="
                                employee.employeeBank
                                  ? employee.employeeBank
                                  : ''
                              "
                              v-model="selectedBank"
                              placeholder="Select Bank"
                              :custom-label="nameOfDesignationEdit"
                              :options="banks"
                              :searchable="true"
                              @select="optionSelectDesignationEdit"
                              :allow-empty="false"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.lookupDescription }}</template
                              >
                            </multiselectvue> -->
                            <select
                              class="form-control"
                              v-if="
                                employee.employeeBank
                                  ? employee.employeeBank.bankName
                                  : ''
                              "
                              v-model="employee.employeeBank.bankName"
                            >
                              <option>Select Bank</option>
                              <option
                                v-for="item in banks"
                                :key="item.lookupValue"
                                :value="item.lookupDescription"
                              >
                                {{ item.lookupDescription }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <!-- <div class="col-md-12">
                          <div class="form-group">
                            <label
                              >Bank Verification Number
                              <span class="text-danger">*</span></label
                            >
                            <input
                              v-if="
                                employee.employeeBank
                                  ? employee.employeeBank.bvnNumber
                                  : ''
                              "
                              class="form-control"
                              v-model="employee.employeeBank.bvnNumber"
                              type="text"
                            />
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Family Info Modal -->

        <!-- Assign Expense II-->
        <v-dialog v-model="modalIIDialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Assign Level II Expense Approver</h5>
              <button type="button" class="close" @click="closeIIDialog()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="addIIManager">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Manager</label>

                      <multiselectvue
                        class="from-control"
                        v-model="manager"
                        placeholder="Select Employee"
                        :custom-label="nameOfEmployee"
                        :options="sortedEmployeeNames"
                        :searchable="true"
                        @select="optionSelected"
                        :allow-empty="false"
                      >
                        <template slot="singleLabel" slot-scope="{ option }"
                          >{{ option.firstName }}
                          {{ option.lastName }}</template
                        >
                      </multiselectvue>

                      <!-- <select class="form-control" v-model="manager">
                  <option>Select Staff</option>
                  <option
                    v-for="member in employees"
                    :key="member.id"
                    :value="member.id"
                  >
                    {{ member.lastName + " " + member.firstName }}
                  </option>
                </select> -->
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <v-dialog v-model="modalIDialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Assign Level II Admin Manager</h5>
              <button type="button" class="close" @click="closeIDialog()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="addManager">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Manager</label>

                      <multiselectvue
                        class="from-control"
                        v-model="manager"
                        placeholder="Select Employee"
                        :custom-label="nameOfEmployee"
                        :options="sortedEmployeeNames"
                        :searchable="true"
                        @select="optionSelected"
                        :allow-empty="false"
                      >
                        <template slot="singleLabel" slot-scope="{ option }"
                          >{{ option.firstName }}
                          {{ option.lastName }}</template
                        >
                      </multiselectvue>

                      <!-- <select class="form-control" v-model="manager">
                  <option>Select Staff</option>
                  <option
                    v-for="member in employees"
                    :key="member.id"
                    :value="member.id"
                  >
                    {{ member.lastName + " " + member.firstName }}
                  </option>
                </select> -->
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <v-dialog v-model="modalExpenseDialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Assign Expense Approver</h5>
              <button type="button" class="close" @click="closeExpenseDialog()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="addExpenseManager">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Manager</label>

                      <multiselectvue
                        class="from-control"
                        v-model="manager"
                        placeholder="Select Employee"
                        :custom-label="nameOfEmployee"
                        :options="sortedEmployeeNames"
                        :searchable="true"
                        @select="optionSelected"
                        :allow-empty="false"
                      >
                        <template slot="singleLabel" slot-scope="{ option }"
                          >{{ option.firstName }}
                          {{ option.lastName }}</template
                        >
                      </multiselectvue>

                      <!-- <select class="form-control" v-model="manager">
                  <option>Select Staff</option>
                  <option
                    v-for="member in employees"
                    :key="member.id"
                    :value="member.id"
                  >
                    {{ member.lastName + " " + member.firstName }}
                  </option>
                </select> -->
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <v-dialog v-model="modalAdminDialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Assign Admin Manager</h5>
              <button type="button" class="close" @click="closeAdminDialog()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="addAdminManager">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Manager</label>

                      <multiselectvue
                        class="from-control"
                        v-model="manager"
                        placeholder="Select Employee"
                        :custom-label="nameOfEmployee"
                        :options="sortedEmployeeNames"
                        :searchable="true"
                        @select="optionSelected"
                        :allow-empty="false"
                      >
                        <template slot="singleLabel" slot-scope="{ option }"
                          >{{ option.firstName }}
                          {{ option.lastName }}</template
                        >
                      </multiselectvue>

                      <!-- <select class="form-control" v-model="manager">
                  <option>Select Staff</option>
                  <option
                    v-for="member in employees"
                    :key="member.id"
                    :value="member.id"
                  >
                    {{ member.lastName + " " + member.firstName }}
                  </option>
                </select> -->
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import PersonalInfoModal from "@/components/employees/PersonalInfoModal.vue";
import ProfileModal from "@/components/employees/ProfileModal.vue";
import FamilyInfoModal from "@/components/employees/FamilyInfoModal.vue";
import BankInfoModal from "@/components/employees/BankInfoModal.vue";
import ExperienceModal from "@/components/employees/ExperienceModal.vue";
import EducationModal from "@/components/employees/EducationModal.vue";
import GLIModal from "@/components/employees/GLIModal.vue";
import NextOfKinInfoModal from "@/components/employees/NextOfKinInfoModal.vue";
import EmergencyContactModal from "@/components/employees/EmergencyContactModal.vue";
import Datepicker from "vuejs-datepicker";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import { paymentService } from "@/services/paymentService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    PersonalInfoModal,
    ProfileModal,
    ExperienceModal,
    EducationModal,
    FamilyInfoModal,
    BankInfoModal,
    EmergencyContactModal,
    GLIModal,
    NextOfKinInfoModal,
    Datepicker
  },
  data() {
    return {
      changePhotodialog: false,
      experienceDialog: false,
      profileDialog: false,
      dialogDelete: false,
      submitted: false,
      EductionEditDialog: false,
      personalInfoDialog: false,
      familyInfoDialog: false,
      bankInfoDialog: false,
      bankInfoDialogEdit: false,
      educationDialog: false,
      emergencyContactDialog: false,
      family: {},
      manager: "",
      managerId: "",
      dialogDeleteFamily: false,
      gliDialog: false,
      nextOfKinDialog: false,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      file: null,
      managerId: "",
      companyUnit: "",
      media: "",
      myAccount: false,
      hrAccount: false,
      requireUpdate: false,
      pensionManagers: [],
      taxOffices: [],
      profileGLI: false,
      profileNOK: false,
      modalIDialog: false,
      modalIIDialog: false,
      modalAdminDialog: false,
      modalExpenseDialog: false,
      education: {},
      message: "",
      error: "",
      selectedBank: "",
      banks: [],
      bankAccountNumber: "",
      bankCode: "",
      bankName: "",
      bvnNumber: "",
      employees: [],
      employee: {
        firstName: null,
        gender: "",
        id: this.$route.params.id,
        lastName: "",
        maritalStatus: null,
        nationality: null,
        passportIdentificationNumber: null,
        passportPhoto: null,
        phone: "",
        religion: null,
        employeeBank: {},
        designation: {
          department: {}
        },
        bankDetails: null,
        employeeNextOfKin: null,
        employeeEducations: [],
        employeeEmergencies: [],
        employeeExperiences: [],
        employeeFamilies: [],
        employeeGLIs: [],
        employeePension: {
          id: 0,
          pensionNo: "",
          employeeRate: "0",
          pensionManager: ""
        },
        employeeStatutory: {
          id: 0,
          salaryBasis: "",
          salaryAmount: 0.0
        },
        employeeTax: {
          id: 0,
          tin: "",
          taxCode: "",
          taxOffice: "",
          tax: {}
        },
        employeeNHF: {
          id: 0,
          nhfNo: "",
          state: ""
        }
      },
      employeePF: 0
    };
  },

  validations: {
    bankAccountNumber: { required }
    // bvnNumber: { required }
  },
  watch: {
    requireUpdate(val) {
      if (val) this.GetEmployeeOtherDetails();
    }
  },
  computed: {
    sortedEmployeeNames: function() {
      function compare(a, b) {
        if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
        if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
        return 0;
      }

      return this.employees.sort(compare);
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getAccountSetting();
      this.GetPensionManager();
      this.GetTaxOffice();
      this.GetEmployee();
      this.getBanks();
      this.GetEmployees();

      // console.log(this.currentUser);
      this.myAccount =
        this.currentUser.employee.id == this.employee.id ||
        this.currentUser.roles.includes("HRAdmin");
      this.hrAccount = this.currentUser.roles.includes("HRAdmin");
    } else {
      this.$route.push("/employees");
    }

    this.companyUnit = JSON.parse(localStorage.getItem("companyUnit"));
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  methods: {
    nameOfDesignation({ lookupDescription }) {
      return `${lookupDescription}`;
    },

    optionSelectDesignation(option, id) {
      console.log(option);
      this.bankName = option.lookupDescription;
      this.bankCode = option.lookupValue;
      console.log(this.bankName, this.bankCode);
    },
    nameOfEmployee({ firstName, lastName }) {
      return `${firstName} ${lastName}`;
    },
    optionSelected(option, id) {
      console.log(option.id);
      this.managerId = option.id;
    },
    addManager() {
      var req = { managerId: this.managerId, employeeId: this.employee.id };

      this.loading = true;
      employeeService.addEmployeeManagerII(req).then(
        id => {
          this.message =
            "Added as a Level 2 Manager and Employee Mapped successfully";
          this.GetEmployee();
          this.GetEmployeeOtherDetails();
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    addIIManager() {
      var req = { managerId: this.managerId, employeeId: this.employee.id };

      this.loading = true;
      employeeService.addOperationalEmployeeManagerII(req).then(
        id => {
          this.message =
            "Added as a Level 2 Approver and Employee Mapped successfully";
          this.GetEmployee();
          this.GetEmployeeOtherDetails();
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    addAdminManager() {
      var req = { managerId: this.managerId, employeeId: this.employee.id };

      this.loading = true;
      employeeService.addEmployeeManager(req).then(
        id => {
          this.message =
            "Added as a Level 2 Manager and Employee Mapped successfully";
          this.GetEmployee();
          this.GetEmployeeOtherDetails();
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    addExpenseManager() {
      var req = { managerId: this.managerId, employeeId: this.employee.id };

      this.loading = true;
      employeeService.addOperationalEmployeeManager(req).then(
        id => {
          this.message =
            "Added as a Level 2 Approver and Employee Mapped successfully";
          this.GetEmployee();
          this.GetEmployeeOtherDetails();
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    openIIDialog() {
      this.modalIIDialog = true;
    },
    closeIIDialog() {
      this.modalIIDialog = false;
    },
    openIDialog() {
      this.modalIDialog = true;
    },
    closeIDialog() {
      this.modalIDialog = false;
    },
    openAdminDialog() {
      this.modalAdminDialog = true;
    },
    closeAdminDialog() {
      this.modalAdminDialog = false;
    },
    openExpenseDialog() {
      this.modalExpenseDialog = true;
    },
    closeExpenseDialog() {
      this.modalExpenseDialog = false;
    },
    // nameOfDesignationEdit({ lookupDescription }) {
    //   return `${lookupDescription}`;
    // },

    // optionSelectDesignationEdit(option, id) {
    //   console.log(option);
    //   this.employee.employeeBank.bankName = option.lookupDescription;
    //   this.employee.employeeBank.bankCode = option.lookupValue;
    //   console.log(this.bankName, this.bankCode);
    // },

    postBank() {
      this.submitted = true;

      console.log(
        this.bankAccountNumber,
        this.bankCode,
        this.bankName,
        this.bvnNumber,
        this.employee.id
      );

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      employeeService
        .addEmployeeBank(
          this.employee.id,
          this.bankAccountNumber,
          this.bankCode,
          this.bankName,
          this.bvnNumber
        )
        .then(
          model => {
            this.message = "Bank Info create successfully!";
            this.closeBankInfo();
            this.GetEmployeeOtherDetails();
            employeeService.getEmployeeDetail(this.employee.id).then(
              model => {
                this.employee = model;
                console.log(this.employee);
              },
              error => {
                this.error = error;
              }
            );
          },
          error => {
            this.error = error;
          }
        );
    },

    upDateBank() {
      console.log(this.employee.employeeBank);
      let id = this.employee.employeeBank.id;
      employeeService.updateEmployeeBank(id, this.employee.employeeBank).then(
        model => {
          this.message = "Bank Info update successfully!";
          this.closeBankInfo();
          this.GetEmployee();
          employeeService.getEmployeeDetail(this.employee.id).then(
            model => {
              this.employee = model;
            },
            error => {
              this.error = error;
            }
          );
        },
        error => {
          this.error = error;
        }
      );
    },

    getBanks() {
      organizationService.getBanks().then(o => (this.banks = o));
    },
    postEditedEducation() {
      // this.submitted = true;

      let id = this.education.id;

      employeeService
        .updateEmployeeEducation(id, this.education)
        .then(model => {
          this.message = "Education update successfully!";
          this.closeEducationEdit();
          this.GetEmployee();
        });
    },

    deleteEducationInfo() {
      employeeService.deleteEmployeeEducation(this.education.id).then(() => {
        this.message = "Education delete successfully!";
        this.closeDelete();
        this.closeEducationEdit();
        this.GetEmployee();
      });
    },
    deleteFamilyInfo() {
      employeeService.removeEmployeeFamily(this.family.id).then(() => {
        this.message = "Family delete successfully!";
        this.closeDelete();
        this.closeEducationEdit();
        this.GetEmployeeOtherDetails();
      });
    },

    openProfile() {
      this.profileDialog = true;
      this.requireUpdate = false;
    },
    openPersonalInfo() {
      this.personalInfoDialog = true;
      this.requireUpdate = false;
    },
    openBankInfo() {
      this.bankInfoDialog = true;
      // this.requireUpdate = false;
    },

    openBankInfoEdit() {
      this.bankInfoDialogEdit = true;
      // this.requireUpdate = false;
    },

    OpenDeleteFamilyData(item) {
      this.family = item;
      this.dialogDeleteFamily = true;
    },

    closeBankInfo() {
      // if (employee) this.employee = employee;
      this.bankInfoDialog = false;
      this.bankInfoDialogEdit = false;
      this.error = "";
      this.message = "";
      // this.requireUpdate = true;
    },

    closeDelete() {
      this.dialogDelete = false;
      this.dialogDeleteFamily = false;
      this.message = "";
      this.error = "";
    },
    openDeleteEducation() {
      this.dialogDelete = true;
    },
    closeEducationEdit() {
      this.EductionEditDialog = false;
    },
    openEducationEdit(item) {
      this.education = item;
      this.EductionEditDialog = true;
      console.log(item);
    },
    openEducation() {
      this.educationDialog = true;
      this.requireUpdate = false;
    },
    openGLI() {
      this.gliDialog = true;
      this.requireUpdate = false;
    },
    openNOK() {
      this.nextOfKinDialog = true;
      this.requireUpdate = false;
    },
    openEmergencyContact() {
      this.emergencyContactDialog = true;
      this.requireUpdate = false;
    },
    openExperience() {
      this.experienceDialog = true;
      this.requireUpdate = false;
    },
    openFamilyInfo() {
      this.familyInfoDialog = true;
      this.requireUpdate = false;
    },
    openChangePhoto() {
      this.changePhotodialog = true;
    },

    closeProfile(employee) {
      if (employee) this.employee = employee;
      this.profileDialog = false;
      this.requireUpdate = true;
    },
    closePersonalInfo(employee) {
      if (employee) this.employee = employee;
      this.personalInfoDialog = false;
      this.requireUpdate = true;
    },
    // closeBankInfo(employee) {
    //   if (employee) this.employee = employee;
    //   this.bankInfoDialog = false;
    //   this.requireUpdate = true;
    // },
    closeEducation(employee) {
      if (employee) this.employee = employee;
      this.educationDialog = false;
      this.requireUpdate = true;
    },
    closeGLI(employee) {
      if (employee) this.employee = employee;
      this.gliDialog = false;
      this.requireUpdate = true;
    },
    closeNOK(employee) {
      if (employee) this.employee = employee;
      this.nextOfKinDialog = false;
      this.requireUpdate = true;
    },
    closeEmergencyContact(employee) {
      if (employee) this.employee = employee;
      this.emergencyContactDialog = false;
      this.requireUpdate = true;
    },
    closeExperience(employee) {
      if (employee) this.employee = employee;
      this.experienceDialog = false;
      this.requireUpdate = true;
    },
    closeFamilyInfo(employee) {
      if (employee) this.employee = employee;
      this.familyInfoDialog = false;
      this.requireUpdate = true;
    },
    closeChangePhoto() {
      this.changePhotodialog = false;
    },
    handleFileUpload() {
      this.$refs.file.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.file = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.file = files[0];
      employeeService.changeEmployeePhoto(files[0], this.employee.id).then(
        model => {
          this.employee = model;
          if (!this.employee.employeePension) {
            this.employee.employeePension = {
              id: 0,
              pensionNo: "",
              employeeRate: "0",
              pensionManager: ""
            };
          } else {
            this.employee.employeePension.employeeRate = model.employeePension.employeeRate.toString();
          }
          if (!this.employee.employeeStatutory) {
            this.employee.employeeStatutory = {
              id: 0,
              salaryBasis: "",
              salaryAmount: 0.0
            };
          }
          if (!this.employee.employeeTax) {
            this.employee.employeeTax = {
              id: 0,
              tin: "",
              taxCode: "",
              taxOffice: "",
              tax: {}
            };
          }
          if (!this.employee.employeeNHFNo) {
            this.employee.employeeNHFNo = {
              id: 0,
              nhfNo: "",
              state: ""
            };
          } else {
            this.employee.employeeTax.tax = {
              taxOffice: this.employee.employeeTax.taxCode,
              description: this.employee.employeeTax.taxOffice
            };
          }

          this.closeChangePhoto();
        },
        e => (this.imageError = e.title)
      );
    },
    changeTax(event) {
      var v = event.target.value;
      var tax = this.taxOffices.find(c => c.taxOffice == v);
      this.employee.employeeTax.taxCode = tax.taxOffice;
      this.employee.employeeTax.taxOffice = tax.description;
    },
    getAccountSetting() {
      organizationService.getAccountSetting(this.company.id).then(o => {
        (this.profileNOK = o.profileNOK), (this.profileGLI = o.profileGLI);
      });
    },
    GetPensionManager() {
      organizationService.getPensions().then(model => {
        this.pensionManagers = model;
        console.log(model);
      });
    },

    GetTaxOffice() {
      organizationService.getStates().then(
        model => (this.taxOffices = model),
        err => {}
      );
    },
    GetEmployee() {
      employeeService.getEmployeeDetail(this.$route.params.id).then(
        model => {
          this.employee = model;
          this.employee.employeePension = {
            id: 0,
            pensionNo: "",
            employeeRate: "0",
            pensionManager: ""
          };
          this.employee.employeeStatutory = {
            id: 0,
            salaryBasis: "",
            salaryAmount: 0.0
          };
          this.employee.employeeTax = {
            id: 0,
            tin: "",
            taxCode: "",
            taxOffice: "",
            tax: {}
          };

          this.employee.employeeNHF = {
            id: 0,
            nhfNo: "",
            state: ""
          };

          this.GetEmployeeOtherDetails();
        },
        error => {
          this.error = error;
        }
      );
    },
    GetEmployeeOtherDetails() {
      employeeService.getEmployeeOtherDetail(this.$route.params.id).then(
        model => {
          this.employee.employeeBank = model.employeeBank;
          this.employee.employeeTax = model.employeeTax;
          this.employee.employeePension = model.employeePension;
          this.employee.employeeStatutory = model.employeeStatutory;
          this.employee.employeeEducations = model.employeeEducations;
          this.employee.employeeExperiences = model.employeeExperiences;
          this.employee.employeeEmergencies = model.employeeEmergencies;
          this.employee.employeeFamilies = model.employeeFamilies;
          this.employee.employeeGLIs = model.employeeGLIs;
          this.employee.employeeHMO = model.employeeHMO;
          this.employee.employeeNextOfKin = model.employeeNextOfKin;
          this.employee.employeeNHF = model.employeeNHF;

          console.log(this.employee.employeeBank);

          if (!this.employee.employeePension) {
            this.employee.employeePension = {
              id: 0,
              pensionNo: "",
              employeeRate: "0",
              pensionManager: ""
            };
          } else {
            this.employee.employeePension.employeeRate = model.employeePension.employeeRate.toString();
          }
          if (!this.employee.employeeStatutory) {
            this.employee.employeeStatutory = {
              id: 0,
              salaryBasis: "",
              salaryAmount: 0.0
            };
          }
          if (!this.employee.employeeTax) {
            this.employee.employeeTax = {
              id: 0,
              tin: "",
              taxCode: "",
              taxOffice: "",
              tax: {}
            };
          } else {
            this.employee.employeeTax.tax = {
              taxOffice: this.employee.employeeTax.taxCode,
              description: this.employee.employeeTax.taxOffice
            };
          }
          if (!this.employee.employeeNHF) {
            this.employee.employeeNHF = {
              id: 0,
              nhfNo: "",
              state: ""
            };
          }
        },
        error => {
          this.error = error;
        }
      );
    },
    onPostStatutory() {
      this.employee.employeeStatutory.salaryBasis = "monthly";

      if (!this.employee.employeeStatutory.id) {
        this.employee.employeeStatutory.salaryAmount = parseInt(
          this.employee.employeeStatutory.salaryAmount
        );
        this.employee.employeePension.employeeRate = parseInt(
          this.employee.employeePension.employeeRate
        );
        employeeService
          .addEmployeeStatutory(
            this.employee.id,
            this.employee.employeeStatutory,
            this.employee.employeePension,
            this.employee.employeeTax,
            this.employee.employeeNHF
          )
          .then(
            model => {
              this.GetEmployee();
            },
            error => {
              this.error = error;
            }
          );
      } else {
        this.employee.employeeStatutory.salaryAmount = parseInt(
          this.employee.employeeStatutory.salaryAmount
        );
        this.employee.employeePension.employeeRate = parseInt(
          this.employee.employeePension.employeeRate
        );
        employeeService
          .updateEmployeeStatutory(
            this.employee.id,
            this.employee.employeeStatutory,
            this.employee.employeePension,
            this.employee.employeeTax,
            this.employee.employeeNHF
          )
          .then(
            model => {
              this.GetEmployee();
            },
            error => {
              this.error = error;
            }
          );
      }
    },
    GetEmployees() {
      employeeService.getAllEmployees(this.company.id).then(
        model => {
          this.employees = model;
        },
        error => {
          this.error = error;
        }
      );
    }
  },

  name: "profile",
  beforeRouteUpdate(to, from, next) {
    // employeeService.getEmployeeDetail(to.params.id).then(
    //     (model) => {
    //       this.employee = model;

    //       if (!this.employee.employeePension) {
    //         this.employee.employeePension = {
    //           id: 0,
    //           pensionNo: "",
    //           employeeRate: "0",
    //           pensionManager: "",
    //         };
    //       } else {
    //         this.employee.employeePension.employeeRate = model.employeePension.employeeRate.toString();
    //       }
    //       if (!this.employee.employeeStatutory) {
    //         this.employee.employeeStatutory = {
    //           id: 0,
    //           salaryBasis: "",
    //           salaryAmount: 0.0,
    //         };
    //       }
    //       if (!this.employee.employeeTax) {
    //                 this.employee.employeeTax = {
    //                   id: 0,
    //                   tin: "",
    //                   taxCode: "",
    //                   taxOffice: "",
    //                   tax: {}
    //                 }
    //               }else{
    //                 this.employee.employeeTax.tax = { taxOffice: this.employee.employeeTax.taxCode, description: this.employee.employeeTax.taxOffice}
    //               }
    //     },
    //     (error) => {
    //       this.error = error;
    //     }
    //   );
    // next();
    next();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/employees/details.vue